import { RenderableBase } from './renderable-base';

export class RenderableSubmit extends RenderableBase<string> {
}
